module.exports = __webpack_public_path__ + "img/stopwatch-20.3748611f.svg";